import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Produkt',
      links: [
        { name: 'Úvod', path: '/' },
        { name: 'Využití', path: '/vyuziti' },
        { name: 'Ceník', path: '/cenik' },
        { name: 'Jak začít', path: '/jak-zacit' },
        { name: 'FAQ', path: '/faq' }
      ]
    },
    {
      title: 'Podpora',
      links: [
        { name: 'Podpora', path: '/podpora' },
        { name: 'Kontakt', path: '/kontakt' },
        { name: 'FAQ', path: '/faq' }
      ]
    },
    {
      title: 'Právní',
      links: [
        { name: 'Ochrana osobních údajů', path: '/ochrana-udaju' },
        { name: 'Obchodní podmínky', path: '/podminky' }
      ]
    }
  ];

  return (
    <footer 
      className="bg-white border-t-2 border-[color:var(--border)] py-12 md:py-16"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_smartedu-ai-4/artifacts/2da2chy6_skolobotlogo.png" 
                alt="Školobot Logo" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-sm text-[color:var(--text-secondary)] leading-relaxed mb-6 max-w-sm">
              AI vytvořená pro každodenní práci českých pedagogů.
            </p>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-center gap-2 text-[color:var(--text-secondary)]">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@skolobot.cz" className="hover:text-[color:var(--primary-500)] transition-colors">
                  info@skolobot.cz
                </a>
              </div>
              <div className="flex items-center gap-2 text-[color:var(--text-secondary)]">
                <Phone className="w-4 h-4" />
                <a href="tel:+420583033357" className="hover:text-[color:var(--primary-500)] transition-colors">
                  +420 583 033 357
                </a>
              </div>
            </div>
          </div>

          {footerLinks.map((column, index) => (
            <div key={index}>
              <h4 className="text-sm font-semibold text-[color:var(--text-primary)] mb-4">
                {column.title}
              </h4>
              <ul className="space-y-3">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.path}
                      className="text-sm text-[color:var(--text-secondary)] hover:text-[color:var(--primary-500)] transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-[color:var(--border)]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[color:var(--text-secondary)]">
              © {currentYear} Školobot. Všechna práva vyhrazena.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;